exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".getting-started{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding-top:30px;padding-left:0px;padding-right:0px}.getting-started #welcome{color:#2d9aa6;font-weight:800;font-size:30px;text-align:center}.getting-started #demonstrate{font-size:22px;text-align:center}.getting-started #experience{color:#808080;font-weight:900;font-size:22px;text-align:center}.getting-started #assessment-card{background-color:#2d9aa6;width:320px;height:60px;cursor:pointer}.getting-started #assessment{color:#FFFFFF;font-size:20px;padding-top:10px;text-align:center}.getting-started #tour{color:#808080;font-weight:500;font-size:22px;text-align:center;text-decoration:underline;cursor:pointer}@media screen and (max-width: 571px){.getting-started{padding-left:30px;padding-right:30px}}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/scss/component/getting-started.scss
// module id = 3834
// module chunks = 3